import React from "react";
import { Field, reduxForm } from "redux-form";

import BasicField from "../components/BasicField";
import PasswordField from "../components/PasswordField";
import { CONSTANTS } from "../modules/constants";
import { validatePass } from "../services/validators";

import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

const validate = values => {
  const errors = {};

  if (!values.code) {
    errors.code = "Required";
  }

  if (!values.password) {
    errors.password = "Required";
  }
  else {
    var res = validatePass(values.password);

    if (!res.valid) {
      errors.password = res.message;
    }
  }

  if (CONSTANTS.ENTER_PASSWORD_TWICE) {
    if (!values.password2) {
      errors.password2 = "Required";
    }
    else {
      if (values.password !== values.password2) {
        errors.password2 = "Both passwords must match";
      }
    }
  }

  return errors;
};

const SetNewPasswordForm = ({ handleSubmit, invalid, pristine, submitting }) => {
  return (
    <form onSubmit={handleSubmit}>
      <div className="field">
        <Field name="code" label="Confirmation Code" type="text" component={BasicField} />
      </div>
      <div className="field">
        <Field name="password" label="New Password" type="password" autoComplete="new-password" component={PasswordField} />
      </div>
      {CONSTANTS.ENTER_PASSWORD_TWICE && <div className="field">
        <Field name="password2" label="Confirm New Password" type="password" autoComplete="new-password" component={PasswordField} />
      </div>
      }
      <Button
        type="submit"
        className="fullWidthButton"
        variant="contained"
        color="primary"
        size="large"
        disabled={invalid || pristine || submitting}>
        {submitting ? <CircularProgress size={24} /> : "Set New Password"}
      </Button>
    </form>
  );
};

export default reduxForm({ form: "setNewPassword", validate })(SetNewPasswordForm);